import { render, staticRenderFns } from "./smsLogin.vue?vue&type=template&id=157c605b&scoped=true&"
import script from "./smsLogin.vue?vue&type=script&lang=js&"
export * from "./smsLogin.vue?vue&type=script&lang=js&"
import style0 from "./smsLogin.vue?vue&type=style&index=0&id=157c605b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c605b",
  null
  
)

export default component.exports